module.exports = __webpack_public_path__ + "media/src/images/site-top/illust4-a91a6b18f1c0b13f562ce00531494d8c.png";